// extracted by mini-css-extract-plugin
export default {"captions":"JX1pg"};